import * as XLSX from "xlsx";

const excelSheetCreate = (worksheetData: any) => {
	const workbook = XLSX.utils.book_new();
	const fileType =
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

	const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
	XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

	const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
	return new Blob([excelBuffer], { type: fileType });
};

const downloadExcelSheet = (blob: any, name: string) => {
	const url = window.URL.createObjectURL(blob);
	const a = document.createElement("a");
	a.href = url;
	a.download = `${name}.xlsx`;
	a.id = "download-link";
	a.click();
	window.URL.revokeObjectURL(url);
	const downloadLink = document.getElementById("download-link");
	if (downloadLink) downloadLink.remove();
};

export const createExcelForMailList = (mails: any) => {
	const worksheetData = [
		[
			"Recipient Name",
			"Recipient Address",
			"Senders Name",
			"Senders Address",
			"Status",
			"Assigned Responsible",
			"Actual Receive Date",
			"SPS Document Type",
			"Platform Upload Date",
			"Folder Name",
			"Last Updated Date",
			"Id",
		],
	];

	for (let mail of mails) {
		const mailServerTime = mail.mailServerTime;
		const formattedMailServerTime = new Date(mailServerTime).toLocaleDateString("en-US");

		worksheetData.push([
			mail.sendTo.name || "N/A",
			mail.sendTo.address || "N/A",
			mail.sendFrom.name || "N/A",
			mail.sendFrom.address || "N/A",
			mail.status || "Unassigned",
			mail.lastUpdatedBy || "N/A",
			formattedMailServerTime,
			mail.spsDocumentType || "N/A",
			new Date(mail.createdAt).toLocaleDateString("en-US") || "N/A",
			mail.folderName,
			new Date(mail.updatedAt).toLocaleDateString("en-US") || "N/A",
			mail.objectId,
		]);
	}

	const blob = excelSheetCreate(worksheetData);
	downloadExcelSheet(blob, "Mail List");
};

export const createExcelForEmailList = (emails: any) => {
	const worksheetData = [
		[
			"Subject",
			"Sent From",
			"Status",
			"Assigned Responsible",
			"Actual Receive Date",
			"Platform Upload Date",
			"Last Updated Date",
			"Id",
		],
	];

	for (let email of emails) {
		const emailServerTime = email.emailServerTime;
		const formattedEmailServerTime = new Date(emailServerTime).toLocaleDateString("en-US");

		worksheetData.push([
			email.subject || "N/A",
			email.sendFrom || "N/A",
			email.status || "Unassigned",
			email.lastUpdatedBy || "N/A",
			formattedEmailServerTime,
			new Date(email.createdAt).toLocaleDateString("en-US") || "N/A",
			new Date(email.updatedAt).toLocaleDateString("en-US") || "N/A",
			email.objectId,
		]);
	}

	const blob = excelSheetCreate(worksheetData);
	downloadExcelSheet(blob, "Email List");
};

export const createExcelHoaList = (headers: any, rows: any) => {
	let worksheets = [headers];
	for (const row of rows) {
		worksheets.push([
			row.name || "N/A",
			row.objectId || "N/A",
			row?.propertyManager?.propertyManagerName || "N/A",
			row.market || "N/A",
			row.city || "N/A",
			row.address || "N/A",
			row.numberOfProperties || "N/A",
			row.updatedAt || "N/A",
			row.masterHoaId ? 'Sub-HOA': 'Master-HOA',
		]);
	}
	const blob = excelSheetCreate(worksheets);
	downloadExcelSheet(blob, `HOAs List-(${new Date().toLocaleDateString()})`);
};

export const createExcelPropertyList = (headers: any, rows: any) => {
	let worksheets = [headers];
	for (const row of rows) {
		worksheets.push([
			row.fullAddress || "N/A",
			row.objectId || "N/A",
			row.hoaPropertyDetails?.externalId || "N/A",
			row?.info?.city || "N/A",
			row.organizationName || "N/A",
			row?.hoaPropertyDetails?.market || "N/A",
			row.updatedAt || "N/A",
			row.hoaId  ? 'Linked' : 'Unlinked',
			row.addedBy || "N/A",
		]);
	}
	const blob = excelSheetCreate(worksheets);
	downloadExcelSheet(blob, `Property List-(${new Date().toLocaleDateString()})`);
};
